import { firebase, auth, db, storage, functions, serverTimestamp } from "./ui/firebase";

// Re-export instances for legacy imports throughout the app
export { firebase, auth, db, storage, functions, serverTimestamp };
export default firebase;

// --- V9 Modular Adapters (Compatibility Layer) ---
// These adapters allow the rest of the app (written with V9 syntax) to use the Compat SDK instances
export const collection = (firestore: any, path: string) => firestore.collection(path);
export const doc = (firestore: any, path: string, ...segments: string[]) => {
  if (segments.length > 0) return firestore.collection(path).doc(segments[0]);
  return firestore.doc(path);
};
export const getDoc = (ref: any) => ref.get();
export const getDocs = (query: any) => query.get();
export const setDoc = (ref: any, data: any, options?: any) => ref.set(data, options);
export const updateDoc = (ref: any, data: any) => ref.update(data);
export const addDoc = (colRef: any, data: any) => colRef.add(data);
export const deleteDoc = (ref: any) => ref.delete();

// Query Builders
export const query = (colRef: any, ...constraints: any[]) => {
  let q = colRef;
  for (const c of constraints) {
    if (c.type === "where") q = q.where(c.field, c.op, c.val);
    if (c.type === "orderBy") q = q.orderBy(c.field, c.dir);
    if (c.type === "limit") q = q.limit(c.val);
  }
  return q;
};
export const where = (field: string, op: string, val: any) => ({ type: "where", field, op, val });
export const orderBy = (field: string, dir: string = "asc") => ({ type: "orderBy", field, dir });
export const limit = (val: number) => ({ type: "limit", val });
